type Props = {
  stage: number;
  onMarkReady: () => void;
  onSimulatePublish: () => void;
};

export default function PublishFlow({ stage, onMarkReady, onSimulatePublish }: Props) {
  const ready = stage >= 3;
  const published = stage >= 4;

  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="w-9 h-9 rounded-md bg-accent-100 text-accent-800 flex items-center justify-center text-lg"><i className="ri-send-plane-line"></i></span>
          <h3 className="font-heading font-bold text-xl text-foreground-950">Publishing workflow</h3>
        </div>
        <span className="bg-secondary-100 text-secondary-900 border border-secondary-200 font-label font-bold uppercase tracking-widest text-[10px] px-2.5 py-1 rounded-sm whitespace-nowrap">
          Demo Preview — No content is saved or published
        </span>
      </div>

      <p className="mt-3 text-sm text-foreground-600">
        The five stages above show how a story would move from upload to publication once the platform is built. This preview never publishes anything.
      </p>

      <div className="mt-4 flex flex-wrap gap-3">
        <button
          type="button"
          onClick={onMarkReady}
          disabled={ready}
          className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 disabled:opacity-40 disabled:cursor-not-allowed text-background-50 font-label font-bold uppercase tracking-wider text-xs px-4 py-2.5 rounded-md whitespace-nowrap cursor-pointer transition-colors"
        >
          <span className="w-4 h-4 flex items-center justify-center"><i className="ri-checkbox-circle-line"></i></span>
          {ready ? 'Marked ready to publish' : 'Mark story ready to publish'}
        </button>
        <button
          type="button"
          onClick={onSimulatePublish}
          disabled={!ready}
          className="inline-flex items-center gap-2 border border-foreground-300 hover:border-foreground-800 disabled:opacity-40 disabled:cursor-not-allowed text-foreground-800 font-label font-bold uppercase tracking-wider text-xs px-4 py-2.5 rounded-md whitespace-nowrap cursor-pointer transition-colors"
        >
          <span className="w-4 h-4 flex items-center justify-center"><i className="ri-flask-line"></i></span>
          Simulate publish
        </button>
      </div>

      {published ? (
        <p className="mt-4 bg-secondary-50 border border-secondary-200 text-secondary-900 text-sm rounded-md px-4 py-3 flex items-start gap-2">
          <span className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0"><i className="ri-information-line"></i></span>
          <span><strong className="font-semibold">Simulation only.</strong> Nothing was published or saved. In the live product this story would move to the public News feed.</span>
        </p>
      ) : ready ? (
        <p className="mt-4 text-xs text-foreground-500 flex items-center gap-1.5">
          <span className="w-4 h-4 flex items-center justify-center"><i className="ri-information-line"></i></span>
          Ready for review. Publishing is disabled in this demo preview.
        </p>
      ) : null}
    </div>
  );
}